import { render, staticRenderFns } from "./ApplicationFormIndividualBasic.vue?vue&type=template&id=5da57bf7&scoped=true"
import script from "./ApplicationFormIndividualBasic.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormIndividualBasic.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationFormIndividualBasic.vue?vue&type=style&index=0&id=5da57bf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da57bf7",
  null
  
)

export default component.exports